<template lang="pug">
#metadata-tab
  b-field(label="Speaker" expanded)
    elasticsearch-multiselect(
      :value="episode.speaker_id"
      :maxtags="1"
      :allow-new="true"
      placeholder="Search by name..."
      field="full_name"
      icon="microphone"
      index="doxa_speakers"
      @add="addSpeaker"
      @input="setSpeakerId($event, 'speaker_id')"
    )
  b-field(label="Collections / Series")
    elasticsearch-multiselect(
      :value="episode.collection_ids"
      :allow-new="true"
      placeholder="Search by title..."
      field="title"
      index="doxa_episode_collections"
      @add="addCollection"
      @input="set($event, 'collection_ids')"
    )
  b-field(label="Tags")
    elasticsearch-multiselect(
      :value="episode.tag_ids"
      :allow-new="true"
      field="label"
      icon="tag"
      index="doxa_tags"
      placeholder="Search by tag..."
      @add="addTag"
      @input="set($event, 'tag_ids')"
    )
  //- b-field(label="Short Description")
  //-   b-input(
  //-     type="textarea"
  //-     :value="episode.short_desc"
  //-     rows="2"
  //-     @input="set($event, 'short_desc')"
  //-   )
  b-field(label="Description")
    b-input(
      type="textarea"
      :value="episode.long_desc"
      rows="5"
      @input="set($event, 'long_desc')"
    )
</template>

<script>
import { mapGetters } from 'vuex';
import ElasticsearchMultiselect from '@/components/form/ElasticsearchMultiselect';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'metadata-tab',
  components: {
    ElasticsearchMultiselect,
  },
  computed: {
    ...mapGetters({
      episode: getters.GET_EPISODE,
    }),
  },
  methods: {
    async addCollection(val) {
      if (typeof (val) === 'string') {
        const payload = {
          title: val,
        };
        const { data } = await this.$store.dispatch(actions.DO_CREATE_COLLECTION, payload);
        const index = _.indexOf(this.episode.collection_ids, val);
        this.$store.commit(mutations.SET_EPISODE_COLLECTION_AT_INDEX, {
          index,
          val: data.episode_collections[0].id,
        });
      }
    },
    async addSpeaker(val) {
      if (typeof (val) === 'string') {
        const payload = {
          full_name: val,
          category: 'guest',
        };
        const { data } = await this.$store.dispatch(actions.DO_CREATE_SPEAKER, payload);
        this.$store.commit(mutations.SET_EPISODE_FIELD, {
          key: 'speaker_id',
          val: data.speakers[0].id,
        });
      }
    },
    async addTag(val) {
      if (typeof (val) === 'string') {
        const payload = {
          label: val,
        };
        const { data } = await this.$store.dispatch(actions.DO_CREATE_TAG, payload);
        const index = _.indexOf(this.episode.tag_ids, val);
        this.$store.commit(mutations.SET_EPISODE_TAG_AT_INDEX, {
          index,
          val: data.tags[0].id,
        });
      }
    },
    set(val, key) {
      this.$store.commit(mutations.SET_EPISODE_FIELD, {
        key,
        val,
      });
    },
    setSpeakerId(val, key) {
      this.$store.commit(mutations.SET_EPISODE_FIELD, {
        key,
        val: val[0],
      });
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/form/episode/MetadataTab.vue